import React from 'react';

import Rating from '~/src/components/rating/Rating';

import initPolyglot from '~/src/utilities/libs/polyglot';

import css from './RatingOverlay.module.scss';
import i18nStrings from './RatingOverlay.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

const RatingOverlay = ({metadataId, onRating, onClose}) => {
    return (
        <div className={css.overlay}>
            <div className={css.content}>
                <button className={css.close} onClick={onClose} title={getTranslation('close')}></button>
                <Rating metadataId={metadataId} onRating={onRating} />
            </div>
        </div>
    );
};

export default RatingOverlay;
